import React, { Component } from 'react'
import GoogleLoginUI from './GoogleLoginUI.js'

class GoogleLoginSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    return (
      <GoogleLoginUI
        context={this.props.context}
        messageList={this.props.messageList}
        onClick={this.onClick}
      />
    )
  }

  onClick = (event) => {
    event.preventDefault()
    window.location = this.props.socialLoginUrl.googleLoginUrl
  }
}

export default GoogleLoginSF
